<script lang="ts">
    import { getContext } from 'svelte'

    import Icon from '@iconify/svelte'

    import type { HydriaDocument } from 'hydria/HydriaDocument'
    import MdeEditor from 'hydria/components/MdeEditor.svelte'
    import Modal from 'hydria/components/Modal.svelte'
    import { type TGettext, gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    const Document = getContext('Document') as HydriaDocument

    let value: string = $state()

    function load(currentValue: string) {
        if (value !== currentValue) value = currentValue
    }

    interface Props {
        saved: string
        value: string
        disabled?: boolean
        showLabel?: boolean
        label?: any
        helpText?: TGettext | 'default'
        isValid?: any
        save?: (v: string) => void
    }

    let { saved: savedValue, value: currentValue = $bindable(), disabled = false, showLabel = true, label = tgettext('Introduction'), helpText = $bindable('default'), isValid = (value: string) => true, save }: Props = $props()
    if (helpText === 'default') helpText = tgettext('Ce texte est affiché au début de la page. Ne pas oublier d’y inclure le titre principal.')

    let savedIsValid = isValid(savedValue)
    let isOpen = $state(false)

    function keep() {
        if (save) save(value)
        else {
            currentValue = value
        }
        close()
    }

    function open() {
        load(currentValue)
        isOpen = true
    }
    function close() {
        isOpen = false
    }

    let isPristine = $derived(currentValue === savedValue)

    let statusIcon: string = $derived.by(() => {
        if (isPristine) {
            return savedIsValid ? 'mdi:check-circle' : 'mdi:alert'
        } else if (isValid(currentValue)) {
            return 'mdi:undo'
        } else {
            return 'mdi:undo'
        }
    })
    let statusClass: string = $derived.by(() => {
        if (isPristine) {
            return savedIsValid ? 'btn-link' : 'btn-danger'
        } else if (isValid(currentValue)) {
            return 'btn-outline-warning'
        } else {
            return 'btn-outline-danger'
        }
    })
</script>

<style>
    pre {
        white-space: pre-line;
        max-height: 75vh;
        overflow: auto hidden;
    }
</style>

<div class="row g-3 align-items-baseline">
    {#if showLabel}
        <div class="col-2 text-end"><label aria-hidden="true" for="nothing" class="control-label" onclick={() => open()}>{$resolve(label)}</label></div>
    {/if}
    <div class="col">
        {#if isOpen}
            <Modal close={() => close()} keep={() => keep()} modalClasses="modal-xl">
                <div class="modal-header text-bg-primary">{$resolve(label)}</div>
                <div class="modal-body">
                    <MdeEditor bind:value {Document} />
                    {#if helpText != null}
                        <div class="form-text">{$resolve(helpText)}</div>
                    {/if}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
                    <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value) || value === currentValue} onclick={() => keep()}>{$_('Appliquer')}</button>
                </div>
            </Modal>
        {/if}
        <div aria-hidden="true" ondblclick={() => open()}>
            {#if currentValue && currentValue != ''}
                <pre>{currentValue}</pre>
            {:else}
                <em class="text-muted">{$_('non-configuré')}</em>
            {/if}
        </div>
        {#if helpText != null}
            <div class="form-text">{$resolve(helpText)}</div>
        {/if}
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {statusClass}"
            disabled={isPristine}
            onclick={() => {
                currentValue = savedValue
            }}><Icon inline icon={statusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => open()}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
